module.exports = __webpack_public_path__ + "static/lucaswork7-61014c702cf9eed7df4aa19f9ee1ccb0.jpg";